import { useAppSelector } from '@common/hooks/store';
import { getUserId, selectUserCurrencyCode } from '@features/auth/slice/authSlice';
import { useFetchSurveyBannerQuery } from '@features/survey/api/surveyApi';
import { formatSum, positiveOrNull } from '@features/survey/runtime/runtimeLogic';
import { openSurvey } from '@features/survey/runtime/surveyBus';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function SurveyBanner() {
  const currencyCode = useAppSelector(selectUserCurrencyCode) ?? '';
  const userId = useAppSelector(getUserId);
  const { data } = useFetchSurveyBannerQuery(userId ?? 0, { skip: !userId, refetchOnMountOrArgChange: 60 });

  if (!data || data.display !== 'banner') {
    return null;
  }

  const teaser = positiveOrNull(data.reward?.sum);
  const handleClick = () => {
    openSurvey(data.surveyId, 'cabinet_banner', data.campaignId ?? null);
  };

  return (
    <Box p={1} pb={0}>
      <Card variant="outlined" sx={{ borderColor: 'warning.main' }}>
        <CardActionArea onClick={handleClick} sx={{ p: 1.25 }}>
          <Stack direction="row" spacing={1} alignItems="flex-start">
            <CardGiftcardIcon color="warning" sx={{ mt: 0.25 }}/>
            <Box minWidth={0} flex="1 1 auto">
              <Typography variant="body2" fontWeight={700}>
                <FormattedMessage id="SURVEY_BANNER_TITLE"/>
              </Typography>
              <Typography variant="caption" color="text.secondary" component="p" sx={{ overflowWrap: 'anywhere' }}>
                {data.title}
              </Typography>
            </Box>
          </Stack>
          {teaser !== null && (
            <Chip
              size="small"
              color="warning"
              variant="outlined"
              sx={{ mt: 1, maxWidth: '100%', height: 'auto', py: 0.25, '.MuiChip-label': { whiteSpace: 'normal' } }}
              label={<FormattedMessage id="SURVEY_INTRO_REWARD" values={{ sum: formatSum(teaser), currency: currencyCode }}/>}
            />
          )}
          <Button component="span" size="small" color="warning" variant="contained" fullWidth sx={{ mt: 1 }}>
            <FormattedMessage id={data.resume ? 'SURVEY_CONTINUE' : 'SURVEY_BANNER_ACTION'}/>
          </Button>
        </CardActionArea>
      </Card>
    </Box>
  );
}
